import Bugsnag from '@bugsnag/js'
// import BugsnagPerformance from '@bugsnag/browser-performance'

const appConfig = window.polyestershoppen.config
const bugsnagConfig = window.polyestershoppen.bugsnag

// Where our build files are served from, e.g. https://polyestershoppen.nl/build/.
// Taken from the script running this, as assets may be on another host than
// the page. Matching on "/build/" alone isn't enough: third-party scripts like
// https://app.aiden.cx/webshop/build/aiden-embedded.min.js use that path too.
const buildUrl = new URL('.', document.currentScript?.src ?? `${window.location.origin}/build/`).href

Bugsnag.start({
  apiKey: bugsnagConfig.apiKey,
  appVersion: appConfig.version.code,
  releaseStage: bugsnagConfig.releaseStage,
  enabledReleaseStages: ['production', 'staging'],
  onError: (event) => {
    // Errors passed to Bugsnag.notify() were reported on purpose by our own
    // code, including inline scripts, so always keep those.
    if (!event.unhandled) {
      return true
    }

    const frames = event.errors[0]?.stacktrace ?? []

    // Scripts injected at runtime (GTM custom HTML tags, browser extensions,
    // in-app browsers) have no file of their own, so their frames point at the
    // page URL. An uncaught error whose stack trace never passes through our
    // own build files is not ours to fix. Bugsnag's own chunk doesn't count:
    // it wraps fetch, XHR, timers and event listeners for every script, so its
    // frames also turn up in third-party errors (see webpack.config.mjs).
    return frames.length === 0 || frames.some(({ file }) => file?.startsWith(buildUrl) && !file.startsWith(`${buildUrl}bugsnag.`))
  },
})

// The customer is fetched rather than rendered into the page (config.html.twig),
// so errors reported before it arrives have no user.
window.polyestershoppen.customer.then((customer) => {
  if (customer) {
    Bugsnag.setUser(String(customer.id), customer.email)
  }
})

// Keep the global available for backwards compatibility and debugging.
window.Bugsnag = Bugsnag

// BugsnagPerformance.start({
//   apiKey: bugsnagConfig.apiKey,
//   appVersion: appConfig.version.code,
//   releaseStage: bugsnagConfig.releaseStage,
//   enabledReleaseStages: ['production'],
//   bugsnag: Bugsnag,
// })
